module.exports = __webpack_public_path__ + "static/media/416GriffinStNW_2018-06-05_44.e15b2a28.jpg";